var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "search-view-container" },
    [
      _c(
        "div",
        { staticClass: "header-container" },
        [
          _c(
            _setup.LfHeaderTitleComponent,
            {
              staticClass: "header",
              attrs: {
                title: _setup.TEXT.title,
                badgeIcon: _setup.ICON.beta,
                badgeTooltip: _setup.TEXT.betaTooltip,
              },
            },
            [
              _setup.queryDone
                ? _c(_setup.LfLabelButtonComponent, {
                    staticClass: "button",
                    attrs: {
                      text: _setup.TEXT.newQuery,
                      prependIconSrc: _setup.ICON.add,
                      action: _setup.onNewQueryClick,
                      variant: _setup.LabelButtonVariant.SOLID,
                      iconColor: "invert(1)",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(_setup.SearchAdvanceIAComponent, { key: _setup.componentKey }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }